import { buildApiUrl } from '../../config/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BajaUsuarios = ({ token }) => {
  const [colaboradores, setColaboradores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showBajaModal, setShowBajaModal] = useState(false);
  const [selectedColaborador, setSelectedColaborador] = useState(null);
  const [bajaForm, setBajaForm] = useState({
    motivo_baja: '',
    fecha_baja: '',
    comentario: ''
  });

  useEffect(() => {
    fetchColaboradores();
  }, []);

  const fetchColaboradores = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(buildApiUrl('/api/colaboradores?perfiles=Administrador,Asesor comisionista,Jefe,Callcenter,Back,BackRecupero,Calidad,Reclutador,rrhh,consultas,Gerente'), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setColaboradores(response.data.colaboradores || []);
    } catch (err) {
      console.error('Error al cargar colaboradores:', err);
      setError('Error al cargar la lista de colaboradores');
      setColaboradores([]);
    } finally {
      setLoading(false);
    }
  };

  const handleBajaColaborador = (colaborador) => {
    setSelectedColaborador(colaborador);
    setBajaForm({
      motivo_baja: '',
      fecha_baja: new Date().toISOString().split('T')[0],
      comentario: ''
    });
    setShowBajaModal(true);
    setError('');
    setSuccess('');
  };

  const handleConfirmarBaja = async () => {
    if (!bajaForm.motivo_baja || !bajaForm.fecha_baja) {
      setError('Motivo y fecha de baja son obligatorios');
      return;
    }

    try {
      await axios.post(buildApiUrl('/api/colaboradores/${selectedColaborador.id}/baja'), bajaForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setSuccess('Colaborador dado de baja correctamente');
      setShowBajaModal(false);
      fetchColaboradores(); // Recargar la lista
    } catch (err) {
      setError('Error al dar de baja al colaborador');
    }
  };

  const getEstadoClass = (estado) => {
    switch (estado?.toUpperCase()) {
      case 'ACTIVO':
        return 'usuarios-estado-activo';
      case 'BAJA':
        return 'usuarios-estado-baja';
      default:
        return 'usuarios-estado-pendiente';
    }
  };

  const handleFormChange = (e) => {
    setBajaForm({
      ...bajaForm,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="usuarios-table-container">
      <div className="usuarios-table-header">
        <h2 className="usuarios-table-title">Baja de Colaboradores</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
      </div>
      <div className="usuarios-table-wrapper">
        <table className="usuarios-table">
          <thead>
            <tr>
              <th>DNI</th>
              <th>Nombres y Apellidos</th>
              <th>Región</th>
              <th>Supervisor</th>
              <th>Jefe</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="loading-cell">
                  <div className="loading">Cargando colaboradores...</div>
                </td>
              </tr>
            ) : colaboradores.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-data">
                  No hay colaboradores registrados
                </td>
              </tr>
            ) : (
              colaboradores.map(colaborador => (
                <tr key={colaborador.id}>
                  <td>{colaborador.dni || '-'}</td>
                  <td>{`${colaborador.nombres || ''} ${colaborador.apellidos || ''}`.trim()}</td>
                  <td>{colaborador.region || '-'}</td>
                  <td>{colaborador.supervisor || '-'}</td>
                  <td>{colaborador.jefe || '-'}</td>
                  <td>
                    <span className={`usuarios-estado ${getEstadoClass(colaborador.estado)}`}>
                      {colaborador.estado || 'PENDIENTE'}
                    </span>
                  </td>
                  <td>
                    <button 
                      className="usuarios-btn usuarios-btn-danger usuarios-btn-sm"
                      onClick={() => handleBajaColaborador(colaborador)}
                      disabled={colaborador.estado === 'BAJA'}
                    >
                      Baja
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      
      {/* Sub-tarjeta para baja de colaborador */}
      {showBajaModal && selectedColaborador && (
        <div className="sub-card-overlay">
          <div className="sub-card">
            <div className="sub-card-header">
              <h3>Baja de Colaborador</h3>
              <button 
                className="sub-card-close"
                onClick={() => setShowBajaModal(false)}
              >
                ×
              </button>
            </div>
            
            <div className="sub-card-content">
              <div className="colaborador-info">
                <div className="info-row">
                  <span className="info-label">Colaborador:</span>
                  <span className="info-value">{selectedColaborador.nombres} {selectedColaborador.apellidos}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">DNI:</span>
                  <span className="info-value">{selectedColaborador.dni}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Región:</span>
                  <span className="info-value">{selectedColaborador.region || '-'}</span>
                </div>
              </div>
              
              <div className="form-group">
                <label>Motivo de la Baja:</label>
                <select 
                  name="motivo_baja"
                  value={bajaForm.motivo_baja}
                  onChange={handleFormChange}
                  className="sub-card-select"
                  required
                >
                  <option value="">Seleccionar motivo</option>
                  <option value="renuncia">Renuncia voluntaria</option>
                  <option value="despido">Despido</option>
                  <option value="fin_contrato">Fin de contrato</option>
                  <option value="otro">Otro</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>Fecha de Baja:</label>
                <input 
                  type="date" 
                  name="fecha_baja"
                  value={bajaForm.fecha_baja}
                  onChange={handleFormChange}
                  className="sub-card-input"
                  required
                  readOnly // Fecha de baja no debe cambiar una vez registrada
                />
              </div>
              
              <div className="form-group">
                <label>Comentario:</label>
                <textarea 
                  name="comentario"
                  value={bajaForm.comentario}
                  onChange={handleFormChange}
                  className="sub-card-textarea"
                  rows="3" 
                  placeholder="Ingrese comentarios adicionales..."
                />
              </div>
              
              {error && <div className="sub-card-error">{error}</div>}
              {success && <div className="sub-card-success">{success}</div>}
            </div>
            
            <div className="sub-card-actions">
              <button 
                className="sub-card-btn sub-card-btn-secondary"
                onClick={() => setShowBajaModal(false)}
              >
                Cancelar
              </button>
              <button 
                className="sub-card-btn sub-card-btn-danger"
                onClick={handleConfirmarBaja}
              >
                Confirmar Baja
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BajaUsuarios; 